export default "__VITE_ASSET__BhQcKwAm__"